import * as THREE from "three";

// What each grab does to the rider and board (#8): the tuck, where the hand
// goes and the board's signature tweak. `skater-model.ts` poses them.

/**
 * A grab tuck: the hips drop toward the board, the board comes up to the
 * rider (knees folding), and the chest leans over it. Whatever the arm still
 * can't reach, the board is pulled the rest of the way to the hand.
 */
export const GRAB_TUCK_DROP = 0.15;
export const GRAB_TUCK_LIFT = 0.2;
export const GRAB_TUCK_LEAN = 0.3;

/**
 * Where each grab's hand goes: which arm, and the spot on the deck in the
 * board's own space (nose +z, heel edge +x).
 */
export const GRAB_SPOTS: Record<string, ["front" | "back", THREE.Vector3]> = {
  Nosegrab: ["front", new THREE.Vector3(0, 0.02, 0.34)],
  Tailgrab: ["back", new THREE.Vector3(0, 0.02, -0.34)],
  Indy: ["back", new THREE.Vector3(-0.13, 0, -0.02)],
  Melon: ["front", new THREE.Vector3(0.13, 0, 0.02)],
  Method: ["front", new THREE.Vector3(0.13, 0, 0.05)],
};

/**
 * Each grab's signature tweak (#8), eased in once the hand is on the board:
 * the board turned in its own space (`pitch` + tips the nose down, `roll` +
 * lifts the heel edge, `yaw` + swings the nose toward the heels), pushed
 * (`push`, metres, board space: +x heels, +y up, +z nose), and the chest's
 * extra lean over the board (`lean`, + forward; an arch is negative).
 */
export interface GrabTweak {
  pitch: number;
  roll: number;
  yaw: number;
  push: [number, number, number];
  lean: number;
}

export const GRAB_TWEAKS: Record<string, GrabTweak> = {
  // Nose pulled up to the front hand, back leg boned straight.
  Nosegrab: { pitch: -0.55, roll: 0, yaw: 0, push: [0, 0.04, 0.1], lean: 0.05 },
  // Tail pulled up to the back hand, front leg boned.
  Tailgrab: { pitch: 0.55, roll: 0, yaw: 0, push: [0, 0.04, -0.1], lean: 0.05 },
  // Back hand on the toe edge, board poked out in front, grip turned to the rider.
  Indy: { pitch: 0.1, roll: 0.35, yaw: 0, push: [-0.08, 0.02, 0], lean: -0.05 },
  // Front hand on the heel edge, board poked out behind, front leg boned.
  Melon: { pitch: 0.2, roll: -0.35, yaw: -0.15, push: [0.1, 0, 0], lean: 0.1 },
  // Front hand on the heel edge, board arched up behind the back, chest open.
  Method: { pitch: 0.35, roll: 0.75, yaw: 0.1, push: [0.14, 0.1, 0], lean: -0.25 },
};
